var map = {
	"./qs0.jpg": 9942,
	"./qs1.jpg": 1555,
	"./qs10.jpg": 7771,
	"./qs11.jpg": 1934,
	"./qs12.jpg": 6953,
	"./qs13.jpg": 2604,
	"./qs2.jpg": 1508,
	"./qs3.jpg": 9553,
	"./qs4.jpg": 7858,
	"./qs5.jpg": 4239,
	"./qs6.jpg": 1248,
	"./qs7.jpg": 6813,
	"./qs8.jpg": 9070,
	"./qs9.jpg": 4027
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1779;